import { render, staticRenderFns } from "./WhitelistDetail.vue?vue&type=template&id=78b65726&"
import script from "./WhitelistDetail.vue?vue&type=script&lang=js&"
export * from "./WhitelistDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports